import React, { useEffect, useState } from 'react'
import { Container, Card, Row, Col, Form, ButtonGroup, Button, Modal } from "react-bootstrap";
import PageTitle from '../components/common/PageTitle';
import { useTranslation } from 'react-i18next';
import api from '../api/api';
import swal from 'sweetalert';
import Pagination from '../views/Pagination';
import '../styles/management-pages.css';
import './ConfigurationManagement.css';

const Configuration = () => {

    const [countrysPerPage] = useState(12)
    const [currentPage, setCurrentPage] = useState(1);

    const [SearchCode, setSearchCode] = useState('')
    const [SearchName, setSearchName] = useState('')


    const paginate = pageNumber => setCurrentPage(pageNumber);

    const { t } = useTranslation();

    const [lat, setLat] = useState("")

    const [lon, setLon] = useState("")




    const [toggle ,setToggle] = useState(false)

    const [allCountry, setAllCountry] = useState([])


    const [city, setCity] = useState("")
    const [countryCode, setCountryCode] = useState("")
    const [country, setCountry] = useState("")

    const [showAddCountry, setShowAddCountry] = useState(false)
    const [newCountryName, setNewCountryName] = useState("")
    const [newCountryIso, setNewCountryIso] = useState("")


  

    const getCountries = async () => {
        try {
            await api.get('/countries/get-countries')
                .then(response => {
                    if (response.data.type === "success") {
                        let listCountries = response.data.Countries
                        setAllCountry(listCountries)
                    }
                }).catch(error => {
                    console.error(error)
                })
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        getCountries()
    }, [])

    const addCountry = () => {
        if (!newCountryName.trim() || !newCountryIso.trim()) {
            swal({ icon: "error", title: t("error"), text: t("fill_required_fields") })
            return
        }
        api.post('/countries/add-country', { name: newCountryName, iso: newCountryIso })
            .then(response => {
                if (response.data.type === "danger") {
                    swal({ icon: "error", title: t("Oops..."), text: t("existed_country") })
                    return
                }
                swal(`${t('country_added')}`, { icon: "success" })
                setShowAddCountry(false)
                setNewCountryName("")
                setNewCountryIso("")
                getCountries()
            }).catch(error => {
                console.error(error)
                swal({ icon: "error", title: t("Oops..."), text: t("error") })
            })
    }

    const getSingleCountry = async (countryIso) => {

        let data = {
            iso: countryIso,

        }

        await api.post('/countries/get-country', data)
            .then(res => {
                let countryData = res.data.country
                setCountry(countryData.name)
                setCountryCode(countryData.iso)

            }).catch(error => {
                console.error(error)

            })
        setToggle(!toggle)

    }

    const addCities = () => {
        let data = {
            country : country,
            iso : countryCode ,
            city : city,
            lat : lat,
            lon :lon

        }

        api.post('/cities/add-cities',data)
        .then(response=>{
            if(response && response.data.type === "success"){
                swal(`${t('City_Added')}`, { icon: "success" });
            }
            if(response && response.data.type === "danger"){
                swal(`${t('error')}`, { icon: "error" });
            }
        }).catch(error=>{
            console.error(error)
        })
        setToggle(false)
    }



    const filteredCountries = allCountry.filter(countries => {
        if (SearchName !== '') {
            return (
                countries.name.toLowerCase().includes(SearchName.toLowerCase())
            )
        }
        if (SearchCode !== '') {
            return (
                countries.iso.toLowerCase().includes(SearchCode.toLowerCase())
            )
        }
        return countries
    })
    const indexOfLastPost = currentPage * countrysPerPage;
    const indexOfFirstPost = indexOfLastPost - countrysPerPage;
    const currentCountries = filteredCountries.slice(indexOfFirstPost, indexOfLastPost);



    return (
        <>
        <Container fluid className="management-page admin-management-page configuration-management-page">
            <header className="management-page-header">
                <div className="management-page-heading">
                    <span className="management-page-eyebrow">SMARTFARM / ADMIN</span>
                    <h1>{t('Countries_Configuration')}</h1>
                    <p>{t('Countries_Configuration')}</p>
                </div>
                <span className="management-header-icon" aria-hidden="true">
                    <i className="fas fa-globe" />
                </span>
            </header>
            <section className="management-filter">
                <span className="management-section-label">{t('search')}</span>
                <Row form className="d-flex justify-content-start gap-2 mt-2">
                    <Col md="3" className="form-group">
                        <Form.Group>
                            <div className="d-flex">
                                <Form.Control
                                    value={SearchName}
                                    onChange={(e) => setSearchName(e.target.value)}
                                    id="search-name"
                                   placeholder={t("search_by_name")}/>

                            </div>
                        </Form.Group>
                    </Col>
                    <Col md="3" className="form-group">
                        <Form.Group>
                            <div className="d-flex">
                                <Form.Control
                                     value={SearchCode}
                                     onChange={(e) => setSearchCode(e.target.value)}
                                    id="search-code"
                                   placeholder={t("search_by_code")} />

                            </div>
                        </Form.Group>
                    </Col>
                </Row>
            </section>
                <Row form className="py-3 d-flex justify-content-end">
                    <ButtonGroup>
                        <Button className="management-primary-button" variant="primary" onClick={() => setShowAddCountry(true)}>
                            <i className="fas fa-plus me-2" aria-hidden="true" />{t("add_country")}
                        </Button>
                    </ButtonGroup>
                </Row>
                <Card className="management-card">
                    <Card.Header className="border-bottom">
                        <div>
                            <h5>
                                {t('Location_Info')}

                            </h5>

                        </div>
                    </Card.Header>
                    <Card.Body>
                    <table className="table mb-0 text-center table-responsive-lg">
                        <thead className="bg-light">
                            <tr>
                                <th scope="col" className="border-0">{t('Name')}</th>
                                <th scope="col" className="border-0">{t('code')}</th>
                                <th scope="col" className="border-0"></th>
                                <th scope="col" className="border-0"></th>

                            </tr>
                        </thead>
                        <tbody>
                            {
                                currentCountries.map(country=>{
                                    return(
                                        <tr>
                                            <td>{country.name}</td>
                                            <td>{country.iso}</td>


                                            <td>
                                               
                                                        <ButtonGroup size="sm" className="mr-2">
                                                            <Button title={t('feature_not_available')} disabled><i className="fas fa-pen" aria-hidden="true" /></Button>
                                                            <Button title={t('feature_not_available')} disabled variant="danger"><i className="fas fa-trash" aria-hidden="true" /></Button>
                                                        </ButtonGroup>
                                                

                                            </td>
                                            <td>
                                               
                                                        <ButtonGroup size="sm" className="mr-2">
<Button variant="outline-primary" onClick={() => getSingleCountry(country.iso)}>
  {t("add_city")}
</Button>
                                                        </ButtonGroup>
                                                

                                            </td>
                                            
                                        </tr>

                                    )
                                })
                            }


                        </tbody>
                    </table>
                    </Card.Body>
                </Card>
                <Row className="py-4 justify-content-center">
                    <Pagination usersPerPage={countrysPerPage} totalUsers={filteredCountries.length} paginate={paginate} currentPage={currentPage} />

                </Row>
        </Container>
<Modal centered={true} show={toggle} onHide={() => setToggle(false)}>
  <Modal.Header closeButton className="d-flex justify-content-between align-items-center">
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
        width: "100%",
      }}
    >
      <Button
        onClick={() => addCities()}
        className="mb-2 mr-1 btn btn-success"
      >
        <i className="fa fa-check mx-2"></i>
        {t("save")}
      </Button>
      <Button
        className="mb-2 mr-1 btn btn-danger"
        onClick={() => setToggle(false)}
      >
        <i className="fa fa-times mx-2"></i>
        {t("cancel")}
      </Button>
    </div>
  </Modal.Header>

  <Modal.Body>
    <Row className="d-flex justify-content-between border-bottom">
      <Col lg="4" md="8" sm="8">
        <Form.Group>
          <Form.Label htmlFor="country">{t("Country")}</Form.Label>
          <Form.Control
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            id="country"
            placeholder={t("Country")}
          />
        </Form.Group>
      </Col>
      <Col lg="4" md="8" sm="8">
        <Form.Group>
          <Form.Label htmlFor="countryCode">{t("Country Code")}</Form.Label>
          <Form.Control
            value={countryCode}
            onChange={(e) => setCountryCode(e.target.value)}
            id="countryCode"
            placeholder={t("Country Code")}
          />
        </Form.Group>
      </Col>
    </Row>

    <Row className="py-4 gap-2">
      <Col lg="5" md="8" sm="8">
        <Form.Group>
          <Form.Label htmlFor="city">{t("City Name")}</Form.Label>
          <Form.Control
            value={city}
            onChange={(e) => setCity(e.target.value)}
            id="city"
            placeholder={t("City Name")}
          />
        </Form.Group>
      </Col>
      <Col lg="3" md="8" sm="8">
        <Form.Group>
          <Form.Label htmlFor="lat">{t("Latitude")}</Form.Label>
          <Form.Control
            value={lat}
            onChange={(e) => setLat(e.target.value)}
            id="lat"
            placeholder={t("Latitude")}
          />
        </Form.Group>
      </Col>
      <Col lg="3" md="8" sm="8">
        <Form.Group>
          <Form.Label htmlFor="lon">{t("Longitude")}</Form.Label>
          <Form.Control
            value={lon}
            onChange={(e) => setLon(e.target.value)}
            id="lon"
            placeholder={t("Longitude")}
          />
        </Form.Group>
      </Col>
    </Row>
  </Modal.Body>
</Modal>

<Modal centered={true} show={showAddCountry} onHide={() => setShowAddCountry(false)}>
  <Modal.Header closeButton>
    <Modal.Title>{t('add_country')}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form.Group className="mb-3">
      <Form.Label htmlFor="newCountryName">{t("Country")}</Form.Label>
      <Form.Control
        value={newCountryName}
        onChange={(e) => setNewCountryName(e.target.value)}
        id="newCountryName"
        placeholder={t("Country")}
      />
    </Form.Group>
    <Form.Group>
      <Form.Label htmlFor="newCountryIso">{t("Country Code")}</Form.Label>
      <Form.Control
        value={newCountryIso}
        onChange={(e) => setNewCountryIso(e.target.value)}
        id="newCountryIso"
        placeholder={t("Country Code")}
      />
    </Form.Group>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="outline-primary" onClick={() => setShowAddCountry(false)}>
      {t("cancel")}
    </Button>
    <Button variant="success" onClick={addCountry}>
      {t("save")}
    </Button>
  </Modal.Footer>
</Modal>

        </>
    )
}

export default Configuration
